import axios from 'axios';
import * as Cookies from '../utils/cookies';

export async function setMatchGreenCards(
  league_pk,
  round_pk,
  match_pk,
  by_team,
  green_cards_number
) {
  const token = Cookies.getToken();

  try {
    const res = await axios({
      method: 'POST',
      url:
        process.env.REACT_APP_API_URL +
        `/api/league/leagues/${league_pk}/rounds/${round_pk}/matches/${match_pk}/report_green_cards/`,
      headers: { Authorization: `Bearer ${token}` },
      data: {
        by_team: by_team,
        green_cards_number: green_cards_number,
      },
    });
    return res;
  } catch (error) {
    return { error: error };
  }
}

